import { ComponentProps } from "react";
import * as S from "./styles";
import { Input } from "../../Atoms/Inputs/Input";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { Button } from "../../Atoms/Button";
import {
  useFormCollaboratorEdit,
  FormCollaboratorEditValues,
} from "./useFormCollaboratorEdit";
import { ISelectOptions } from "../../../types/inputs";
import { MessageErroForm } from "../../Atoms/MessageErroForm";
import { InputSwitch } from "../../Atoms/Inputs/InputSwitch";

interface IFormCollaboratorEditProps extends ComponentProps<"form"> {
  submitForm: (data: FormCollaboratorEditValues) => void;
}

export const FormCollaboratorEdit = ({
  submitForm,
  ...rest
}: IFormCollaboratorEditProps) => {
  const {
    control,
    errors,
    handleSubmit,
    perfis,
    register,
    tipoOptions,
    Controller,
    deliverys,
    lojas,
  } = useFormCollaboratorEdit();

  return (
    <S.MyFormCollaboratorRegister {...rest} onSubmit={handleSubmit(submitForm)}>
      <div>
        <Controller
          control={control}
          name="ativo"
          render={({ field: { onChange, value } }) => (
            <InputSwitch
              label={value ? "Ativo" : "Inativo"}
              id="ativo"
              checked={value}
              onChange={(e) => onChange(e?.target?.checked)}
            />
          )}
        />
      </div>
      <div>
        <Input
          id="name"
          data-error={!!errors?.nome}
          {...register("nome")}
          required
          variant="edit"
          label="Nome"
        />
        {errors?.nome && (
          <MessageErroForm>{errors.nome.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Input
          data-error={!!errors?.cpf}
          id="cpf"
          {...register("cpf")}
          disabled
          label="CPF"
          maxLength={15}
        />
        {errors?.cpf && <MessageErroForm>{errors.cpf.message}</MessageErroForm>}
      </div>
      <div>
        <Input
          data-error={!!errors?.email}
          id="email"
          {...register("email")}
          variant="edit"
          label="E-mail"
        />
        {errors?.email && (
          <MessageErroForm>{errors.email.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Controller
          control={control}
          name="tipo"
          render={({ field: { onChange, value } }) => (
            <SimpleSelect
              inputId="tipo"
              data-error={!!errors?.tipo}
              options={tipoOptions}
              required
              label="Tipo"
              value={tipoOptions.find((e) => e.value === value) || null}
              onChange={(e: ISelectOptions) => {
                onChange(e?.value);
              }}
            />
          )}
        />
        {errors?.tipo && (
          <MessageErroForm>{errors.tipo.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Input
          data-error={!!errors?.telefone}
          id="telefone"
          {...register("telefone")}
          disabled
          // required
          label="Telefone"
        />

        {errors?.telefone && (
          <MessageErroForm>{errors.telefone.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Controller
          control={control}
          name="perfis"
          render={({ field: { onChange, value } }) => (
            <SimpleSelect
              data-error={!!errors?.perfis}
              inputId="perfil"
              options={perfis}
              required
              isMulti
              value={perfis.filter((e) =>
                value.find((i) => i.value === e.value)
              )}
              label="Perfil"
              onChange={onChange}
            />
          )}
        />
        {errors?.perfis && (
          <MessageErroForm>{errors.perfis.message}</MessageErroForm>
        )}
      </div>

      <div>
        <Controller
          control={control}
          name="uuidLojas"
          render={({ field: { onChange, value } }) => (
            <SimpleSelect
              data-error={!!errors?.uuidLojas?.message}
              options={lojas}
              isMulti
              value={lojas.filter((e) =>
                value?.find((i) => i.value === e.value)
              )}
              label="Unidades Loja"
              onChange={onChange}
            />
          )}
        />
      </div>

      <div>
        <Controller
          control={control}
          name="uuidDeliverys"
          render={({ field: { onChange, value } }) => (
            <SimpleSelect
              data-error={!!errors?.uuidDeliverys?.message}
              options={deliverys}
              isMulti
              value={deliverys.filter((e) =>
                value?.find((i) => i.value === e.value)
              )}
              label="Unidades Delivery"
              onChange={onChange}
            />
          )}
        />
      </div>
      <div>
        <Button>Salvar</Button>
      </div>
    </S.MyFormCollaboratorRegister>
  );
};
